import { Phone, MapPin, Clock, Radar, Mountain, AlarmClock } from "lucide-react";
import { Reveal, MaskedLines } from "@/components/Reveal";
import LeadForm from "@/components/LeadForm";
import { PHONE_DISPLAY, PHONE_TEL, ADDRESS, CITIES } from "@/data/site";

const Contact = () => (
  <>
    <section data-testid="contact-hero" className="relative overflow-hidden bg-bear-ink py-24 text-white lg:py-28">
      <div className="pointer-events-none absolute -right-8 top-10 select-none font-display text-[24vw] leading-none text-stroke-ghost lg:text-[15rem]">
        CALL
      </div>
      <div className="relative mx-auto max-w-7xl px-4 sm:px-6">
        <div className="flex items-center gap-3">
          <Mountain className="h-4 w-4 text-bear-gold" />
          <span className="font-head text-xs font-bold uppercase tracking-[0.32em] text-bear-gold">
            Contact
          </span>
        </div>
        <h1 className="mt-6 font-display uppercase leading-[0.92] tracking-wide">
          <MaskedLines
            delay={0.15}
            lineClassName="text-[clamp(2.8rem,8.5vw,7.5rem)]"
            lines={[
              <span key="a">Wake</span>,
              <span key="b" className="text-bear-cyan">The Bear<span className="text-bear-gold">.</span></span>,
            ]}
          />
        </h1>
        <Reveal delay={0.5}>
          <p className="mt-8 max-w-xl text-base leading-relaxed text-white/65 sm:text-lg">
            One form or one call — either way, a real local dispatcher answers
            and a certified tech rolls your way.
          </p>
        </Reveal>
      </div>
    </section>

    <section className="bg-bear-paper py-20 lg:py-28">
      <div className="mx-auto grid max-w-7xl items-start gap-10 px-4 sm:px-6 lg:grid-cols-[1fr_1.15fr]">
        <Reveal>
          <div data-testid="contact-details-card" className="rounded-md bg-bear-ink p-8 text-white sm:p-10">
            <h2 className="font-display text-4xl uppercase tracking-wide">
              The Den<span className="text-bear-gold">.</span>
            </h2>
            <div className="mt-8 space-y-7">
              <a href={PHONE_TEL} data-testid="contact-call-link" className="group flex items-start gap-4">
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-bear-red transition-transform duration-300 group-hover:scale-110">
                  <Phone className="h-5 w-5" />
                </span>
                <span>
                  <span className="block font-head text-2xl font-bold">{PHONE_DISPLAY}</span>
                  <span className="text-sm text-white/50">Click-to-call — standard &amp; after-hours</span>
                </span>
              </a>
              <div className="flex items-start gap-4">
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full border border-bear-cyan/40">
                  <MapPin className="h-5 w-5 text-bear-cyan" />
                </span>
                <span>
                  <span className="block font-head text-lg font-bold" data-testid="contact-address">{ADDRESS}</span>
                  <span className="text-sm text-white/50">Home base, dispatch &amp; parts</span>
                </span>
              </div>
              <div className="flex items-start gap-4">
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full border border-bear-gold/40">
                  <Clock className="h-5 w-5 text-bear-gold" />
                </span>
                <span className="w-full">
                  <span className="block font-head text-lg font-bold">Hours</span>
                  <span className="mt-2 block space-y-1.5 text-sm text-white/60">
                    <span className="flex justify-between gap-6 border-b border-white/10 pb-1.5">
                      <span>Mon – Fri</span><span className="text-white">7:30 AM – 5:00 PM</span>
                    </span>
                    <span className="flex justify-between gap-6 border-b border-white/10 pb-1.5">
                      <span>After-Hours (M–F)</span><span className="text-bear-gold">5:00 – 9:00 PM</span>
                    </span>
                    <span className="flex justify-between gap-6">
                      <span>Sat – Sun</span><span className="text-bear-gold">Full Weekend Coverage</span>
                    </span>
                  </span>
                </span>
              </div>
              <div className="flex items-start gap-4">
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full border border-white/20">
                  <Radar className="h-5 w-5 text-bear-cyan" />
                </span>
                <span>
                  <span className="block font-head text-lg font-bold">60-Mile Radius</span>
                  <span className="mt-1 block text-sm leading-relaxed text-white/50">
                    {CITIES.join(" • ")} — and everywhere between.
                  </span>
                </span>
              </div>
            </div>
            <div className="mt-10 flex items-center gap-3 rounded-md border border-bear-red/40 bg-bear-red/10 p-5">
              <AlarmClock className="h-6 w-6 shrink-0 text-bear-red" />
              <p className="text-sm text-white/80">
                <span className="font-head font-bold text-white">Emergency right now?</span>{" "}
                Skip the form — call {PHONE_DISPLAY} and say "urgent."
              </p>
            </div>
          </div>
        </Reveal>
        <Reveal delay={0.15}>
          <LeadForm />
        </Reveal>
      </div>
    </section>
  </>
);

export default Contact;
